import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
interface PricingProps {
  onJoinClick?: () => void;
}
export function Pricing({
  onJoinClick
}: PricingProps) {
  return <section id="pricing" className="py-20 bg-gray-900 text-[#fbf7dd] relative overflow-hidden" data-id="element-367">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#175445] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" data-id="element-368"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 bg-[#FFC107] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000" data-id="element-369"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-370">
        <div className="text-center mb-16" data-id="element-371">
          <div className="inline-block bg-[#FFC107] text-black px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider mb-6" data-id="element-372">
            Early Bird Pricing Available
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-4" data-id="element-373">
            Simple, Transparent <span className="text-[#175445]" data-id="element-374">Pricing</span>
          </h2>
          <div className="h-1 w-24 bg-[#FFC107] mx-auto rounded-full" data-id="element-375"></div>
          <p className="mt-4 text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-376">
            One straightforward rate for caravan and boat storage. Lock in early
            bird pricing by joining the priority list now.
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-377">
          <div className="relative flex flex-col p-10 rounded-2xl border bg-[#fbf7dd] text-gray-900 border-[#175445] shadow-2xl" data-id="element-378">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#FFC107] text-black text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full shadow-lg" data-id="element-379">
              Standard Bay
            </div>

            <div className="mb-6 text-center" data-id="element-380">
              <h3 className="text-3xl font-display font-bold mb-2" data-id="element-381">
                Standard Bay
              </h3>
              <p className="text-sm text-gray-600" data-id="element-382">
                Perfect for caravans, boats and motorhomes. Bay size: 9m x 3m.
              </p>
            </div>

            <div className="mb-8 text-center" data-id="element-383">
              <div className="flex items-baseline justify-center mb-2" data-id="element-384">
                <span className="text-lg font-medium" data-id="element-385">from</span>{' '}
                <span className="text-5xl font-bold" data-id="element-386">$29</span>
                <span className="ml-2 text-lg text-gray-600" data-id="element-387">per week</span>
              </div>
              <div className="text-base font-bold text-[#175445]" data-id="element-388">
                Early bird pricing available
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-389">
              <li className="flex items-start" data-id="element-390">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-391" />
                <span className="text-base font-medium" data-id="element-392">9m x 3m Bay Size</span>
              </li>
              <li className="flex items-start" data-id="element-393">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-394" />
                <span className="text-base font-medium" data-id="element-395">
                  Outdoor Uncovered Storage
                </span>
              </li>
              <li className="flex items-start" data-id="element-396">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-397" />
                <span className="text-base font-medium" data-id="element-398">
                  24/7 Security Monitoring
                </span>
              </li>
              <li className="flex items-start" data-id="element-399">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-400" />
                <span className="text-base font-medium" data-id="element-401">
                  Secure Gated Access
                </span>
              </li>
              <li className="flex items-start" data-id="element-402">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-403" />
                <span className="text-base font-medium" data-id="element-404">
                  Month-by-Month Terms
                </span>
              </li>
              <li className="flex items-start" data-id="element-405">
                <Check className="h-6 w-6 mr-3 flex-shrink-0 text-[#175445]" data-id="element-406" />
                <span className="text-base font-medium" data-id="element-407">
                  Easy Street Access
                </span>
              </li>
            </ul>

            <Button variant="secondary" size="lg" className="w-full text-lg py-6 shadow-lg hover:scale-105 transform transition-transform" onClick={onJoinClick} data-id="element-408">
              Join The Priority List
            </Button>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-409">
          <p className="text-sm text-gray-400" data-id="element-410">
            * Final pricing will be confirmed once site is secured. Early bird
            rates guaranteed for registered customers.
          </p>
        </div>
      </div>
    </section>;
}